import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";

interface NewStateModalFormProps {
  StateValidationSchema: any;
  onCreateNewState: (userDetails: any) => void;
  stateData: {
    stateId: number,
    stateName: string;
  };
  isEdit: boolean;
  onClose: () => void;
}

const NewStateModalForm: React.FC<NewStateModalFormProps> = ({
  StateValidationSchema,
  onCreateNewState,
  stateData,
  isEdit,
  onClose,
}) => {
  const [showModal, setShowModal] = useState(false);

  const handleModalClose = () => {
    setShowModal(false);
    onClose();
  };
  const handleModalOpen = () => setShowModal(true);

  const formik = useFormik({
    initialValues: {
      stateId:isEdit? stateData?.stateId: "",
      stateName: "",
    },
    validationSchema: StateValidationSchema,
    onSubmit: (values, { resetForm }) => {
      onCreateNewState(values);
      resetForm();
      handleModalClose();
    },
  });

  useEffect(() => {
    if (isEdit) {
      formik.setValues({stateId: stateData?.stateId, stateName: stateData?.stateName})
      handleModalOpen();
    }
  }, [isEdit]);

  return (
    <>
      {!isEdit && (
        <Button variant="primary" className="mb-3" onClick={handleModalOpen}>
          Add New State
        </Button>
      )}
      <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? "Update State" : "Add New State"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
          {isEdit && <Form.Group className="mb-3" controlId="stateId">
              <Form.Label>State Name</Form.Label>
              <Form.Control
                readOnly
                defaultValue={isEdit ? stateData?.stateId : ""}
                type="number"
                name="stateId"
                onChange={formik.handleChange}
                isInvalid={
                  !!(formik.touched.stateId && formik.errors.stateId)
                }
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.stateId}
              </Form.Control.Feedback>
            </Form.Group>}
            <Form.Group className="mb-3" controlId="stateName">
              <Form.Label>State Name</Form.Label>
              <Form.Control
                defaultValue={isEdit ? stateData?.stateName : ""}
                type="text"
                name="stateName"
                onChange={formik.handleChange}
                isInvalid={
                  !!(formik.touched.stateName && formik.errors.stateName)
                }
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.stateName}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Close
          </Button>
          <Button variant="primary" onClick={() => formik.handleSubmit()}>
            {isEdit ? "Update" : "Add"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default NewStateModalForm;
